// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"0afbbe04","703":"8256bbd9"}[chunkId] + ".chunk.js";
};